import React from "react";

export const Chip: React.FC<{
  children: React.ReactNode;
  onClick?: () => void;
  active?: boolean;
  "data-testid"?: string;
}> = ({ children, onClick, active, ...rest }) => {
  const Tag = onClick ? "button" : "span";
  return (
    <Tag
      onClick={onClick}
      className={`inline-flex items-center rounded-[10px] px-3 py-1.5 text-xs font-medium transition-colors duration-200 ease-out ${
        active
          ? "bg-ink text-white"
          : onClick
          ? "bg-periwinkle/20 text-ink hover:bg-periwinkle/35"
          : "bg-periwinkle/20 text-ink"
      }`}
      data-testid={rest["data-testid"] || "chip"}
    >
      {children}
    </Tag>
  );
};
